import { useNavigate, useParams, useSearchParams } from "react-router";
import SVG from "react-inlinesvg";
import { TitleHeader } from "../../common/components/TitleHeader/TitleHeader";
import style from "./style.module.scss";
import { StorageTabList } from "./components/StorageTabList";
import { createContext, useEffect, useState } from "react";
import { StorageService } from "./core/_request";
import { Loader } from "../../common/components/Loader/Loader";

export const StorageContext = createContext<any>({} as any);

const StorageDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  // const { detail, setDetail } = useStorageStore();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const storage_type = searchParams.get("storage_type") || "magasin";
  /* const onBack = () => {
    const storage_type = searchParams.get("storage_type") || "magasin";
    navigate(`/app/storage?storage_type=${storage_type}`);
  }; */

  const [initialValue, setInitialValue] = useState<any>(null);

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    try {
      if (id) {
        setIsLoading(true);
        const res = await StorageService.getStorageById(+id);
        setInitialValue(res?.data);
      }
    } catch (err) {
      console.error("Erreur lors de la récupération du stockage:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <StorageContext.Provider value={initialValue}>
      <Loader isLoading={isLoading} />
      <div className="">
        <TitleHeader
          title=""
          isSHowBack
          backUri={`/app/storage?storage_type=${storage_type}`}
          subTitle="Entreposage"
        />
        <div className={`py-1 card-storage px-2 ${style.containter}`}>
          <div className={style.containter__item}>
            <SVG
              src="/media/icon/chart.svg"
              className={style.containter__icon}
              style={{
                color:
                  typeof initialValue?.percentTxt === "undefined"
                    ? "#86590F"
                    : parseInt(initialValue?.percentTxt) < 50
                    ? "#2a8213"
                    : "#e80505",
              }}
            />
            <div className={style.containter__text}>
              <span>Taux de remplissage</span>
              <span>{initialValue?.percentTxt}</span>
            </div>
          </div>
          <div className={style.containter__item}>
            <SVG
              src="/media/icon/warehouse.svg"
              className={style.containter__icon}
              style={{ color: "#032079" }}
            />
            <div className={style.containter__text}>
              <span>Capacité</span>
              <span>{initialValue?.capacityTxt}</span>
            </div>
          </div>
          <div className={style.containter__item}>
            <SVG
              src="/media/icon/box.svg"
              className={style.containter__icon}
              style={{ color: "#d76937" }}
            />
            <div className={style.containter__text}>
              <span>Stockage</span>
              <span>
                {initialValue?.stockTxt === " T"
                  ? "0 T"
                  : initialValue?.stockTxt}
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* LIST */}
      <div>
        <StorageTabList />
      </div>
    </StorageContext.Provider>
  );
};

export default StorageDetail;
